import { Process } from "../data-types/data-types";

export const ourprocess: Process = [
	{
		id: 1,
		title: "Book a Discovery Call",
		text: "We offer a FREE 30-minute Discovery call session with one of our expert coaches, where you get to ask us all your questions about our programs and tell us your expectations. If you are interested in any of our programs, use the link below to fill out our short form and we will get back to you within 24 hours!",
	},
	{
		id: 2,
		title: "Register Your Teen",
		text: "After a successful discovery call, we will send you a link to access our SMARTA Registration portal. Here, you will register your teen with us. Please, note that registration does not guarantee access to our program."
	},
	{
		id: 3,
		title: "Make Your Investment",
		text: "SMARTA parent, your payment validates your teen's registration and access to our programs. Please take note that we require your payment to be received within 72 hours of registration. Also, we have payment plan options if needed. Your child's participation is also important to us and we thank you for ensuring their registration with us."
	},
	{
		id: 4,
		title: "We Do the Magic!",
		text: "After we might have validated your investment, we will activate your teen's portal, and send you the login details. Then, we do the MAGIC over the coaching period."
	}
] 